<template>
    <div class="newsTemplate Wrapper h-100" :style="{backgroundColor:getActiveCanvasObjProps?.backgroundColor || '#ffffff'}">
        <div class="rowPrarentP" :style={...changeLayout()}>
            <div class="newsBG" v-bind:style="{backgroundImage: `url(${currentData?.imgsrc !== undefined ? currentData?.imgsrc : 'https://i.pinimg.com/originals/83/22/fe/8322fe88218111b81b9543a77b614fd6.jpg'})`}"></div>

            <div class="parentWrapper" :style={...createAnimationVar()}>
                <div class="head1" v-bind:style="{color:getActiveCanvasObjProps?.headerColor || '#212529' }"> 
                    <span v-if="newsID.includes('Google')" class="textFitted" v-bind:style={fontSize:this.head1} v-html="currentData?.title"></span>
                    <span v-else class="textFitted" v-bind:style={fontSize:this.head1}> {{ currentData?.title }} </span>
                </div>
                <div class="head2" v-bind:style="{color:getActiveCanvasObjProps?.summaryColor || '#212529' }">
                    <span v-if="newsID.includes('Google')" class="textFitted" v-bind:style={fontSize:this.head2} ></span>
                    <span v-else class="textFitted" v-bind:style={fontSize:this.head2}> {{ currentData?.desc }} </span>
                </div>
                <div class="head3"><span class="textFitted" v-bind:style={fontSize:this.head3}> {{ currentData?.time }} </span></div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
var convert = require('xml-js');

export default {
    name: "NewsTemplate",
    props: {
        newsID:String,
        src: String,
        width: Number,
        height:Number,
    },
    data() {
        return {
            data: [],
            currentData: {
                title: "",
                desc: "",
                time: "",
                imgsrc:""
            },
            intervalId: null,
            head1:14,
            head2:14,
            head3:14,
            transi: false
        }
    },
    watch: {
        width: function() {
            this.setFontSize();
        },
        height: function() {
            this.setFontSize();
        },
        src: function(newValue,oldValue) {
            console.log(oldValue , newValue);
            this.fetchNews(newValue ? newValue : "");
        },

    },
    mounted() {
        this.fetchNews(this.src ? this.src : "");
        this.setFontSize();
    },
    computed:{
        getCanvas() {
            return this.$store.getters.getCurrentActiveCanvas
        },
        getActiveCanvasObjProps() {
            return this.$store.getters.getActiveObjectprops;
        },
    },
    methods: {
        fetchNews(url) {
            let self = this;
            
            if(url.includes("foxnews")){
                axios({
                method: 'get',
                url: url,
                headers: {
                    "Content-Type": "text/xml;charset=UTF-8"
                }
                }).then(function (response) {
                    let xml = response.data;
                    var result1 = convert.xml2json(xml, { compact: true, spaces: 4 });
                    let data = JSON.parse(result1);
                    console.log(data)
                    self.data = data.rss.channel.item;
                    self.startAddingItems(data.rss.channel.item , "fox");
                }).catch(function (error) {
                    console.log(error);
                });
            } else {
                 axios({
                    method: 'get',
                    url: 'https://api.rss2json.com/v1/api.json?rss_url=' + url,
                }).then(function (response) {
                    self.data = response.data.items;
                    self.startAddingItems(response.data.items ,"");
                }).catch(function (error) {
                    console.log(error);
                });
        }
    },
           
        startAddingItems(items , check) {
            let totalItems = items.length;
            let currentItem = 0;
            let newObject = {}; // Reset the newObject

            const addItem = () => {
                this.$nextTick(function () {
                    this.transi = true;
                })
                newObject = items[currentItem];
                let datatoInset = {
                    title: check === "fox" ? newObject?.title._text : newObject?.title,
                    desc: check === "fox" ? newObject?.description._text : newObject?.description,
                    time: check === "fox" ? newObject?.pubDate._text : newObject?.pubDate,
                    imgsrc:check === "fox" ? newObject["media:content"]?._attributes?.url : newObject?.enclosure?.link
                };
                addTrans();
                
                let self = this;
                setTimeout(() => {
                    console.log(datatoInset);
                    self.currentData = datatoInset;
                }, 500);

                // Increment the current item index
                currentItem++;

                // If the current item index exceeds the total items, reset to the first item
                if (currentItem >= totalItems) {
                    currentItem = 0;
                }
            };

            const addTrans = () => {
                this.transi = true;
                let self = this;
                setTimeout(() => {
                    self.transi = false;
                }, 800);
            }
            if (currentItem === 0) {
                addItem();
            }
            // Clear any existing interval
            clearInterval(this.intervalId);

            // Start the interval
            this.intervalId = setInterval(addItem, 10000); // Interval of 10 seconds
        },

        createAnimationVar() {
            let obj = {};

            if (this.transi === false) {
                let mar = this.width/this.getCanvas.zoomRatio < 768 ? (`margin-left: 5%`) : '';
                obj = {
                    'opacity': 1,
                    mar
                }
            } else {
                obj = {
                    'opacity': 0,
                    'transform': 'translateX(100%)',
                }
            }

            return obj
        },
        setFontSize(){
            console.log('testing fontsize')
            const parentHeight = this.height;
            const parentWidth = this.width;
            const fontSizeHead1 = Math.min(parentWidth, parentHeight) / 17;
            const fontSizeHead2 = Math.min(parentHeight, parentWidth) * 0.04;
            const fontSizeHead3 = Math.min(parentHeight, parentWidth) * 0.03;
            this.head1 =  fontSizeHead1 + 'px';
            this.head2 =  fontSizeHead2 + 'px';
            this.head3 =  fontSizeHead3 + 'px';
        },
        changeLayout(){
            let obj = {};
            if((this.width/this.getCanvas.zoomRatio) < 768){
                obj = {
                    'flex-direction': 'column'
                }
            } else {
                obj = {};
            }
            return obj

           
        }
    },
    beforeDestroy() {
        console.log("unmounted called")
        // Clear the interval before the component is unmounted
        clearInterval(this.intervalId);
    }
}

</script>

<style scoped>
.newsBG {
    background-image: url('https://i.pinimg.com/originals/83/22/fe/8322fe88218111b81b9543a77b614fd6.jpg');
    display: block;
    height: 100vh;
    background-repeat: no-repeat;
    background-size: cover;
    -webkit-mask: -webkit-linear-gradient(left, #000 26.9841%, transparent 100%, transparent);
    flex: 50;
    background-position: center;
}

.parentWrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 50;
    padding: 5%;
    padding-left: 5%;
    padding-left: 0;
    margin-left: -10%;
    transition: all 1s ease-in-out;
}

.rowPrarentP {
    display: flex;
    width: 100%;
    height: 100%;
    /* height: 100vh; */
}

.head1 {
    flex: 50;
}

.head2 {
    flex: 30;
    padding-top: 10%;
}

.head3 {
    padding-top: 50px;
    flex: 5;
    flex-shrink: 1;
    flex-shrink: 0;
    color: grey;
}
@media (max-width: 768px){
    .rowPrarentP{
        flex-direction: column;
    }
}
</style>